import { useCallback } from 'react';

const leftShadowClassName = 'left-shadow';
const rightShadowClassName = 'right-shadow';

function toggleShadow(scrollableElement: HTMLElement) {
  const isScrolledToLeft = scrollableElement.scrollLeft === 0;
  const isScrolledToRight =
    scrollableElement.scrollLeft ===
    scrollableElement.scrollWidth - scrollableElement.clientWidth;

  if (isScrolledToLeft) {
    scrollableElement.parentElement?.classList.remove(leftShadowClassName);
  } else {
    scrollableElement.parentElement?.classList.add(leftShadowClassName);
  }

  if (isScrolledToRight) {
    scrollableElement.parentElement?.classList.remove(rightShadowClassName);
  } else {
    scrollableElement.parentElement?.classList.add(rightShadowClassName);
  }
}

const useWithScrollableShadow = (enabled: boolean = true) => {
  return useCallback(
    (scrollableWrapper: HTMLElement | null) => {
      if (!scrollableWrapper) {
        return;
      }

      scrollableWrapper.classList.add('with-scrollable-shadow');

      if (!enabled) {
        // remove previously applied shadows when e.g. resizing the window
        scrollableWrapper.classList.remove(
          leftShadowClassName,
          rightShadowClassName,
        );

        return;
      }

      const scrollListener = (event: Event) => {
        toggleShadow(event.target as HTMLElement);
      };

      scrollableWrapper.firstChild?.addEventListener('scroll', scrollListener);

      // apply shadow on mount if needed
      toggleShadow(scrollableWrapper.firstChild as HTMLElement);
    },
    [enabled],
  );
};

export default useWithScrollableShadow;
